export default class SettingController
{
	constructor($http, $scope, AppService) {
		// Dependancies
		this.$http = $http;
		this.$scope = $scope;
		this.AppService = AppService;
		this.success = false;

		this.$scope.$parent.title = this.title;

		// Set page endpoint
		this.$scope.$parent.endpoint = this.endpoint;
	}

	get endpoint() {
		return 'settings';
	}

	get title() {
		return 'Settings';
	}

	submit() {
		this.$http({
			method: 'POST',
			url: '/auth/password/update',
			data: { password: this.verifyNewPassword }
		}).then((response) => {
			console.log(response);
			this.success = true;
			alert('Password updated successfully');
		}, (response) => {
			alert('Unable to update password');
		});
	}
}



/** WEBPACK FOOTER **
 ** ./resources/assets/js/controllers/setting.controller.js
 **/